import { createSlice } from '@reduxjs/toolkit';

interface otAsset {
    id: string | number,
    ip: string,
    macAddress: string,
    landscape: string,
    displayName: string
}

export interface otAssetState {
    isOtAssetDataLoading: boolean;
    otAssetData: Array<otAsset>;
    otAssetError: boolean;
}

const initialState: otAssetState = {
    isOtAssetDataLoading: false,
    otAssetData: [],
    otAssetError: false,
}

const otAssetReducer = createSlice({
    name: 'otAsset',
    initialState: initialState,
    reducers: {
        getOtAssetDataRequest: (state, action: { payload: string }) => {
            state.isOtAssetDataLoading = true;
        },
        getOtAssetDataResponse: (state, action) => {
            state.isOtAssetDataLoading = false;
            state.otAssetData = action.payload.res;
        },
        getOtAssetDataFailed: (state) => {
            state.isOtAssetDataLoading = false;
            state.otAssetError = true;
        }}
    })


export const otAssetActions = otAssetReducer.actions;
export default otAssetReducer;